import {Component, Vue} from "vue-property-decorator";
import UserModel from "../../models/UserModel";

// export default Vue.extend({
//   computed: {
//     user(): UserModel {
//       return this.$store.getters['context/user'];
//     },
//     userAuthenticated(): boolean {
//       return this.user.isAuthenticated();
//     }
//   }
// });
//
@Component
export default class UserMixin extends Vue {
  get user(): UserModel {
    return this.$store.getters['context/user'];
  }

  get userAuthenticated(): boolean {
    return this.user.isAuthenticated();
  }
}
